// Ducks 구조 = Action + Reducer
import { createAction, handleActions } from "redux-actions";

// Action Types
const CHANGE_MODE = "setting/CHANGE_MODE";
const PEDC_CHECK = "setting/PEDC_CHECK";
const SETTING_TMTBL = "setting/SETTING_TMTBL";
const PEDC_LIST = "setting/PEDC_LIST";

// Action Creators
export const changeMode = (info) => ({ type: CHANGE_MODE, info });
export const pedcCheck = (data) => ({ type: PEDC_CHECK, data });
export const tmtblSetting = (data) => ({ type: SETTING_TMTBL, data });
export const inquiryPedcListPreiod = (data) => ({ type: PEDC_LIST, data });

// Initial
const settingState = {
    mode: false,
    pedcCheck: "N",
    pedcCheckDate: "",
    tmtblSetting: "N",
    inquiryPedcList: [],
};

export default function settingReducer(state = settingState, action) {
    switch (action.type) {
        case CHANGE_MODE:
            return {
                ...state,
                mode: action.info.mode,
            };
        case SETTING_TMTBL:
            return {
                ...state,
                tmtblSetting: action.data.tmtblSetting,
            };
        case PEDC_CHECK:
            return {
                ...state,
                pedcCheckDate: action.data.pedcCheckDate,
                pedcCheck: action.data.pedcCheck,
            };
        case PEDC_LIST:
            return {
                ...state,
                inquiryPedcList: action.data.inquiryPedcList,
            };

        default:
            return state;
    }
}
